// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GitlabFilledSvg from "@ant-design/icons-svg/es/asn/GitlabFilled";
import AntdIcon from '../components/AntdIcon';

var GitlabFilled = function GitlabFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: GitlabFilledSvg
  }));
};

GitlabFilled.displayName = 'GitlabFilled';
export default React.forwardRef(GitlabFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/GitlabFilled.js
// module id = 1265
// module chunks = 0